import appConstants from '@appConstants';

/** Id used in glContainer._config.id so headerId becomes gridHeader_selectDriversMapHeader */
export const SELECT_DRIVERS_MAP_HEADER_ID = 'selectDriversMapHeader';

export const selectDriversMapConfig = {
  autoZoomEnabled: false,
  showOnlySelectedDrivers: true,
  showPickupsFromStep0: true,
  mapHeaderId: SELECT_DRIVERS_MAP_HEADER_ID,
  mapId: appConstants.mapIds.SELECT_DRIVERS_MAP,
  mapContainerId: 'selectDriversMapContainer',
} as const;
